let content = [
    {
      id: "general_trading_conditions",
      title: "General trading Conditions",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Product Details",
          content_before: `<p class="mb-5">
                            iFOREX offers highly competitive conditions for leveraged margin trading of CFDs based on various underlying assets (“Underlying Assets”), including Currency pairs (Forex), Commodies, Indexes, Shares, ETFs and Cryptos ("Instruments" or "Finacial Instruments" or "Leveraged Instruments" or "CFDs" as the context may be).
                            <br><br>
                            <b>Spreads</b><br>The Spread is the cost of trading – it is the difference between the Sell (Bid) price and the Buy (Ask) price. For example, if the USD/JPY is trading at a sell price of 101.202 and a buy price of 101.222, the difference between these two prices is called the spread. In this case the spread is 2 pips.
                            <br><br>
                            <b>Margin and Leverage</b><br>When trading Leveraged Instruments, while the "Margin" acts as collateral to cover any losses that you might incur, it also allows you to hold a position much larger than your actual account value, giving you the possibility to generate large profits relative to the amount invested.
                            <br><br>
                            Leverage is a double-edged sword and can dramatically amplify your profits, however it can also just as easily amplify your losses. When you use excessive leverage, losing trades can quickly offset many winning trades. Leveraged trading carries a high degree of risk and may not be suitable for all investors.
                            <br><br>
                            As an iFOREX account holder, you’re entitled to our Negative Balance Protection program, which means that you can never lose more than you deposited; nonetheless, a small market movement can result in a substantial loss of funds. Our Trading Platform automatically calculates your margin requirements before executing any order, and checks the level of available funds before any request to withdraw funds is made.
                            <br><br>
                            The margin requirements are relevant upon increasing Exposure in the account, either by opening/closing deals or by requesting to withdraw funds while having open positions in the account. The margin requirements reflect the potential risk in positions, based on volatility, liquidity and pricing availability, in any given asset. This is why margins increase during and around trading breaks.
                            </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/trading-conditions/currencies">Currencies</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/commodities">Commodities</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/indices">Indices</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/shares">Shares</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/crypto">Crypto</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Trading Hours",
          content_before: `<p>
                During the European and North American winter, the weekly activity begins on Sunday at 22:05 GMT continuously until Friday, 21:00 GMT. During the Day Light Saving times in these regions, the weekly market activity begins on Sunday at 21:05 GMT and ends on Friday at 20:00. Market activity hours may vary due to public holidays or due to unusual liquidity conditions which may arise from exceptional global events. Opening or Closing times may also be altered by iFOREX due to liquidity and risk management considerations.
              <br><br>
              Although most of the instruments are traded on a 24 hour basis without interruption, some instruments, however, have special trading hours as seen in the table below:
              </p>`,
  
          data_id: "TradingHours",
          
          products: {
            1:"Currencies & Crypto",
            2:"Commodities",
            3:"Indices",
            4:"Shares",
            5:"Metals",
            8:"ETFs"
          },
          table_titles: [
            "Market",
            "Trading Hours (GMT)",
            "1st Daily Break Time (GMT)",
            "2nd Daily Break Time (GMT)",
            "Data Valid Until (GMT)"
          ],
          content_after: `<p>Not sure which Market includes the instrument you're looking for? Click <span class="tclink" target-tab="tc-view-6">here</span> to view the full list of instrument per Market.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Holidays",
          content_before: `<p>
              To ensure that you are aware of all market hours and holidays, please find below a list of events that could change trading hours.<br>
              At iFOREX we do our utmost to keep this information up-to-date on a best efforts basis.<br>
              Should you wish to receive more information please feel free to contact our dealing desk.
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Market",
            "Trading Halt at (GMT)",
            "Trading Resume at (GMT)",
          ],
          content_after: `<p class="mt-4">Not sure which Market includes the instrument you're looking for? Click <span class="tclink" target-tab="tc-view-6">here</span> to view the full list of instrument per Market.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Orders and execution",
          content_before: `<p><b>Order Types</b></p>
  
              <table class="mb-4 table4">
                  <tbody>
                      <tr>
                          <th>MARKET ORDERS</th>
                          <th></th>
                      </tr>
                      <tr>
                          <td>Open Deal</td>
                          <td>An order to open a position at the current available market rate</td>
                      </tr>
                      <tr>
                      <td>Close Deal</td>
                          <td>An order to close a position at the current available market rate</td>
                      </tr>
                  </tbody>
              </table>
  
              <table class="mb-4 table4">
                  <tbody>
                      <tr>
                          <th>LIMIT ORDERS</th>
                          <th></th>
                      </tr>
                      <tr>
                          <td>Stop Loss</td>
                          <td>The Stop Loss is an order to open or close a deal at a rate inferior to the current market rate</td>
                      </tr>
                      <tr>
                          <td>Take Profit</td>
                          <td>The Take Profit is an order to open or close a deal at a rate superior to the current market rate</td>
                      </tr>
                  </tbody>
              </table>
  
              <p>
                  <b>Market Orders</b><br>Market Orders (trade requests) are executed at the price indicated in the Company's server at the time of execution (the "Market Price"), which may differ from the price indicated in the Trading Platform (client side). In the event of a substantial difference between the Market Price and the price indicated in the Trading Platform - which may occur, for example, due to movements in the underlying asset between the time the client places the Order and the time it is received and executed, high market volatility or communication latency - the Order shall be rejected, irrespective of whether the Market Price is higher or lower than the price indicated in the Trading Platform.
              </p>
              <p>
              <b>Limit Orders</b><br>Limit Orders (future orders) are executed at the market price updated at the Company’s servers which may be different than the price indicated in the Order (“Slippage”). Slippage may occur in the event where the price indicated in the order is not available in the servers, for example, due to high volatility and gaps in the market prices. In such event, the order will be executed at the first available price, irrespective of the direction of the slippage, either to the client’s favor or not, in a symmetrical and transparent manner (Symmetrical Slippage).<br><br>Instruments that are not traded on a 24 hours basis (e.g. Shares, Indices and ETFs CFDs), may experience a market gap on a daily basis and are therefore more susceptible to slippage. It is important to note that slippage does not affect the Negative Balance Protection and therefore the Client will never lose more than the amount invested (including any profit, if gained), even if a slippage occurs.
              </p>
              <p>
              <b>Delays in Execution</b><br>A delay in execution may occur for various reasons, such as technical issues with the Client’s internet, mobile or other communication connection to the iFOREX servers, which may result in “hanging orders”. A disturbance in the connection path can sometimes interrupt the signal and disable the platform causing delays in transmission of data between the trader’s platform and the iFOREX server.
              </p>
              <p>
              <b>Hanging Orders</b><br>During periods of heavy trade volume or communication latency, hanging orders may occur, which means that a Limit Order has been placed, but it is simply taking a few moments for it to be confirmed/processed. During periods of heavy trading volumes or communication latency, it is possible that a queue of Limit Orders will form. That increase in incoming orders may sometimes create conditions where there is a delay in confirming/processing certain Limit Orders. In some cases, the position may in fact have been executed and the delay is simply in the client’s side display due to heavy internet traffic.<br><br>Keep in mind that it is only necessary to enter any order once. Multiple entries for the same order may slow or lock your computer or inadvertently open unwanted positions.
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Negative Balance Protection",
          content_before: `<p class="">
                iFOREX's Negative Balance Protection policy guarantees that the client’s losses are limited to the funds invested in the client’s account. According to this policy, the client shall never have to face a debit balance due to trade losses when trading with iFOREX and client’s potential loss shall be limited to the funds deposited in the Client’s account and to the funds gained by the client, if any.
                <br><br>
                To implement this policy, iFOREX developed an automated monitoring tool, automatically closing in real-time all positions once a client’s account reaches Margin Level Zero (i.e. "Exposure Coverage" = 0). iFOREX will automatically close all positions at the price then offered by iFOREX. In the event that a client’s balance falls below Margin Level Zero due to the difference between Margin Level Zero and the actual Margin Level below Zero which the system closed all positions at the price then offered by iFOREX, iFOREX shall bear the mentioned difference.
              </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "bonus_terms_and_conditions",
          id:'btc',
          title: "Bonus Terms and Conditions",
          content_before: `
                 
                      <p>
                          <b>Introduction</b><br>These Bonus Terms and Conditions are in regard to the Trading Bonus, including a Welcome bonus, Cashback Bonus and Trial Account Bonus offered by the Company (hereinafter called the ‘Bonus’), as detailed below, and is considered to be an integral part of the Company’s Terms and Conditions. All interpretation of terms included herein, are as interpreted in Company’s Terms and Conditions, which are available in Company’s website <a href="/">www.iforex.in</a>.
                      </p>
                      <p>
                          <b>Conditions of Eligibility</b><br>Bonuses are available to Company clients who satisfy the eligibility criteria of the relevant offer, pass all required registration procedures according to Company requirements as amended from time-to-time at the sole discretion of the Company, and are approved by the Company as eligible clients (the ‘<b>Eligible Clients</b>‘).
                          <br><br>
                          The Company offers any Bonus at its absolute discretion, to any Client and/or country/region as it deems appropriate.
                          <br><br>
                          The Company reserves the right, at its sole discretion, to decline registration of any user, including Eligible Clients, in the Bonus and/or revoke the offer of any bonus at its absolute discretion.<br><br>Residents form restricted jurisdictions, including residents of the U.S.A, are not eligible for the Trading Bonus.
                      </p>
                      
                      <p>
                          <b>Trading Bonus</b><br>Subject to the General Terms hereunder, Trading Bonus is granted to Eligible Clients as a percentage of the amount of funds deposited in their trading account and/or otherwise as the Company may see fit at its sole discretion.
                          <br><br>
                          Trading bonus is designated for purposes of margin trading only, thus can only be used as extra margin (i.e. the Client will not be able to withdraw the Bonus granted).
                          <br><br>
                          The Trading Bonus is granted per each Eligible Client.
                          <br><br>
                          Welcome Bonus - is a trading bonus for 1st time depositors.
                          </p>
                          
                          <ul class="list-style-dashed">
                          <li class="mt-1 mb-2">In any event of withdrawal of funds, including any transfer of funds to the Vault, the Company may revoke and cancel any bonus granted, in whole or in part, at the Company’s sole discretion.</li>
                         
                          </ul>
                          <br>
                          <p>
                          <u style="font-style:italic">Example</u><br><br>
                          Eligible Client agreed with the Company to receive 30% bonus on his deposit of $1,000. Eligible Client will receive extra Margin of $300 (i.e. 30% of his deposit) as Trading Bonus.<br><br>This bonus will reflect on client’s account as follows:
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Trading Bonus</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,300</td>
                                  <td>$300</td>
                              </tr>
                          </tbody></table>
                      </div>
          
                      <p>
                          Trading bonus will not be available for withdrawal at any time whatsoever. Any profit made by utilizing the Trading Bonus may be withdrawn by the Eligible Client subject to the Company’s withdrawal policy and applicable law. The withdrawable profits made out of the Trading Bonus will be visible under the section "Balance" of the client’s account.
                          <br><br>
                          <u style="font-style:italic">Example</u><br><br>
                          Eligible Client agreed with the Company to receive 30% bonus on his deposit of $1,000. Eligible Client has the below Equity and Balance in his Account:
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Trading Bonus</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,300</td>
                                  <td>$300</td>
                              </tr>
                          </tbody></table>
                      </div>
          
                      <p>
                          <u style="font-style:italic">Scenario A</u><br><br>
                          Client has requested to withdraw the full amount of his deposit ($1,000). Trading bonus will be entirely removed.<br><br>This will reflect on the client’s account as follows:
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Trading Bonus</th>
                              </tr>
                              <tr>
                                  <td>$0</td>
                                  <td>$0</td>
                                  <td>$0</td>
                                  <td>$0</td>
                              </tr>
                          </tbody></table>
                      </div>
                     
                      <p>
                          <u style="font-style:italic">Scenario B</u><br><br>
                          Client has requested to withdraw <b>$800</b>, therefore the client’s Equity was decreased to <b>$200</b> and the Trading Bonus in this <b>case is removed</b>.<br><br>This will reflect on the client’s account as follows:
                      </p>
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Trading Bonus</th>
                              </tr>
                              <tr>
                                  <td>$200</td>
                                  <td>$200</td>
                                  <td>$200</td>
                                  <td>$0</td>
                              </tr>
                          </tbody></table>
                      </div>
          
                      <p>All Trading Bonuses shall be cancelled if the account has remained inactive for 30 consecutive days.</p>
                 
                      
                      <p>
                          <b>Cash Back</b><br>
                          The CashBack program credits Eligible Clients’ account with cash on a weekly basis according and subject to the volume achieved in that week and up to a certain amount as determined in advance by the Company (“Pending Bonus”).<br><br>The Pending Bonus amount may derive from a certain or a number of deposits, as a percentage of the value of the deposit, or determined at the Company’s sole discretion.
                      </p>
                      <p>
                          <u style="font-style:italic">Example</u><br><br>
                          An Eligible Client who deposited $1,000 was entitled to receive up to 40% of the value of his deposit as Cash Back for trading a volume of $20,000,000. Such client will receive $400 as Pending Bonus.<br><br>This Pending Bonus will reflect on Client’s Account as follows:
                      </p>
                      <div class="table-wrapper">
                          <table class="table2 mt-3 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Pending Bonus</th>
                                  <th>Volume Traded</th>
                                  <th>Volume Required</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$400</td>
                                  <td>$0</td>
                                  <td>$20,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>
                          Each week, the Realized CashBack which is calculated according to the client’s weekly volume shall be deducted from the Total CashBack amount (Pending Bonus) and credited to the client’s account according to the ratio between the client’s actual weekly volume (in USD) and the required volume, as indicated in the trading platform. It is clarified that the client is only entitled to the Realized CashBack and the Pending Bonus is realized only after client completes the required volume. The CashBack amount (“Realized CashBack”) is limited to the Pending Bonus allocated to the client.<br><br>The volume is calculated on an ‘in and out’ basis, which means that the opening of a $1 million (or at another currency equivalent) position and the closing of the same position, count as $2 million (or at another currency equivalent) totals towards the client’s volume requirement.
                          <br><br>
                          <u style="font-style:italic">Example</u><br><br>
                          <u style="font-style:italic">Scenario A</u><br><br>
                          The Eligible Client in the previous example, was offered $100 Realized Cash Back for each $5,000,000 traded. After 1 week, he has achieved the $5,000,000 volume. Therefore $100 as Realized CashBack has been moved from Pending Bonus to Equity.<br><br>This will reflect on the client’s account as follows:
                      </p>
          
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Pending Bonus</th>
                                  <th>Volume Traded</th>
                                  <th>Volume Required</th>
                              </tr>
                              <tr>
                                  <td>$1,100</td>
                                  <td>$1,100</td>
                                  <td>$1,100</td>
                                  <td>$300</td>
                                  <td>$5,000,000</td>
                                  <td>$20,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>
                          <u style="font-style:italic">Scenario B</u><br><br>
                          After 2 weeks from the deposit, the client has achieved $5,000,000 volume traded and made $300 of profits. Therefore another $100 as Realized CashBack has been moved from Pending Bonus to Equity.<br><br>This will reflect on the client’s account as follows:
                      </p>
                      
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Pending Bonus</th>
                                  <th>Volume Traded</th>
                                  <th>Volume Required</th>
                              </tr>
                              <tr>
                                  <td>$1,500</td>
                                  <td>$1,500</td>
                                  <td>$1,500</td>
                                  <td>$200</td>
                                  <td>$10,000,000</td>
                                  <td>$20,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>
                          After being credited to the Equity, the Realized CashBack will be available for trading or can be withdrawn by the Client at any time. Any profit made by investing the Realized CashBack amount may as well be withdrawn from the Eligible Client.<br><br>The CashBack promotion is time limited, and the Client receives Realized CashBack within the first 3 months from the day he was granted with the Pending Bonus. The client is Eligible for further CashBack, when he makes further deposits.
                          <br><br>
                          <u style="font-style:italic">Example</u><br><br>
                          The Eligible Client in the previous examples, decided to withdraw his $300 profits and the $200 Realized Cash Back amount received. Therefore he requested a withdrawal of $500 in total. The remaining $200 of Cash Back Bonus will remain as Pending Bonus in his account, therefore the client will still be able to keep on trading with $1,000 and has two and a half months left to convert the Pending Bonus into Realized CashBack.
                          
                          <br><br>This will reflect on the Client’s account as follows:</p>
                      
                      <div class="table-wrapper">
                          <table class="table2 mt-4 mb-4 w-auto">
                              <tbody><tr>
                                  <th>Balance</th>
                                  <th>Equity</th>
                                  <th>Margin Available</th>
                                  <th>Pending Bonus</th>
                                  <th>Volume Traded</th>
                              </tr>
                              <tr>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$1,000</td>
                                  <td>$200</td>
                                  <td>$10,000,000</td>
                              </tr>
                          </tbody></table>
                      </div>
                      
                      <p>All CashBacks are given in the account's currency.</p>
                      
                      <p>
                          <b>Trial Account</b><br>
                          Users may be provided with a trial account that includes a Trading Bonus (as explained above) of US $125 that can be used to trade, subject to the Company’s Trading Conditions.
                          <br><br>
                          The Trial Account shall expire and all pending transactions in the Trial Account shall be terminated within 3 days of the day of the first transaction made in the Trial Account (“Trial Period”). Any amount which exceeds US 25$ (“Profit”) may be used as margin for the user’s trading account with the Company, subject to the user’s successful conclusion of the company’s registration process and a minimum deposit of US 100$, or may be withdrawn to a bank account under the user’s name. Please note that (i) withdrawals are subject to the Company’s withdrawal procedures and may further be subject to a transfer fee, and (ii) any Profit not withdrawn, or transferred to the trading account and used as margin for trading purposes no later than 14 days from the date of opening the first transaction on the Trial Account shall be revoked.
                          <br><br>
                          The Bonus is available only to clients registering with the Company’s platform for the first time and who have satisfied the eligibility criteria described above. Only one Bonus is permitted per residential address/household/IP address. Clients who open more than one account, or who register multiple accounts from the same residential address/household/IP address, shall be deemed to have violated these Terms. In such cases, any Bonuses and Profits generated therefrom on all accounts, except for the first account registered from that residential address/household/IP address, shall be cancelled. The same limitation shall apply to accounts opened by immediate family members. Only the first such account shall be eligible, and any Bonuses and Profits generated therefrom on any subsequent account shall be cancelled.
                      </p>
                      <p>
                          <b>General Terms</b><br>
                          Any indication or suspicion, in the Company’s discretion, of any form of illegal, unfair and\\or abusive trading methods or conducts (including but not limited to trading activity patterns that indicate an aim to benefit financially from the Trading Bonus without taking market risk and\\or by opening, operating or managing more than one account per client) as well as any indication or suspicion of fraud, manipulation or a breach of the Company’s agreements, policies and conditions with respect to the Bonus Scheme will nullify all bonuses previously credited to the account and to any related account. Under such circumstances, the Company shall have the right, in its sole discretion and without derogating from its rights under its agreements with the client and applicable law, to nullify and cancel all transactions carried and/or profits or losses garnered therein and to block all relevant accounts and the Company shall not be liable for any consequences of any of the said actions. 
                          <br><br>
                          Company reserves the right, as is in its sole discretion deems fit to alter, amend, suspend, cancel or terminate any of the above-mentioned Bonus, or any aspect of the above-mentioned offer, at any time.
                      </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Additional Trading Rules",
          content_before: `
              <p>
                    <b>इस्लामिक खाता</b><br/>
                    इस्लामिक (स्वैप-फ्री) खाता कंपनी द्वारा प्रदान की जाने वाली सभी ट्रेड योग्य परिसंपत्तियों पर उपलब्ध है और इसे शरीयत सिद्धांतों के अनुरूप डिज़ाइन किया गया है, क्योंकि इस पर रातभर के स्वैप या रोलओवर ब्याज लागू नहीं होते।

                    यह खाता प्रकार अधिकतम 30 दिनों की अवधि के लिए उपलब्ध है, जिसके बाद कंपनी के विवेकानुसार पोज़िशन स्वचालित रूप से बंद की जा सकती हैं या खाते को परिवर्तित किया जा सकता है।

                    इस्लामिक खाते बोनस, प्रमोशन या कैशबैक कार्यक्रमों के लिए पात्र नहीं हैं।

                    दुरुपयोग या नियम एवं शर्तों का पालन न करने की स्थिति में कंपनी स्वैप-फ्री स्थिति को रद्द करने या उपयुक्त कार्रवाई करने का अधिकार सुरक्षित रखती है।
                    <br/><br/>

                  <b>Margin Call</b><br>
                  iFOREX does not proceed to a compulsory closing of clients’ positions as long as there is positive equity in the client’s account. This enables clients to use their equity to the full extend in order to support their open positions against price fluctuations.
                  <br><br>
                  <b>Margin Information</b><br>
                  The window displayed below provides detailed information related to the margin of an account:
              </p>
  
              <div class="table-wrapper">
                  <table class="table3 mt-4 mb-4">
                      <tbody><tr>
                          <td>Used Margin</td>
                          <td style="color:red">2,500</td>
                      </tr>
                      <tr>
                          <td>Available Margin</td>
                          <td style="color:green">2,495</td>
                      </tr>
                      <tr>
                          <td>Margin Utilization</td>
                          <td style="color:green">+50.05%</td>
                      </tr>
                      <tr>
                          <td>Exposure Coverage</td>
                          <td>+0.50%</td>
                      </tr>
                  </tbody></table>
              </div>
  
              <ul class="list-style-disc-small mb-3">
                  <li><b>Used Margin</b> shows the amount of Equity in an account that is currently being used as Margin for your Open Deals. In the case where Used Margin is equal to or larger than the Equity, this indicates that the account's leverage is Maximized. During and around trading breaks, the Required Margin of some instruments (as detailed in the ‘Product Details table’) increases - and this affects the Available Margin, which might be dramatically reduced during the weekend as a result.<br>Used Margin = Net Exposure in an Instrument x The Required Margin for that Instrument
                  </li>
                  <li><b>Margin Available</b> shows the amount of equity in an account that is not currently being used and is available for further increase of net exposure. In the case where Margin Available is zero, this indicates maximum leverage usage in the account.<br>Margin Available = Equity – Used Margin
                  </li>
                  <li><b>Margin Utilization</b> shows the percentage of Equity that is being used as Margin for the currently Open Deals of the account. 100% Margin Utilization and above, indicates maximum leverage usage in the account.<br>Margin Utilization % = (Used Margin/Equity) x 100
                  </li>
                  <li><b>Exposure Coverage</b> shows what percentage of the Net Exposure of an account is held in equity as collateral.<br>Exposure Coverage = Equity/Net Exposure
                  </li>
              </ul>
  
              <p>
                  <b>Maximum Exposure</b><br>
                  As a prudential measure aimed at better risk management and avoidance of excessive exposure to a single client, iFOREX has set a maximum net exposure limitation of up to 15 (fifteen) million US dollars per client. iFOREX had also set a maximum net exposure for per instrument. To view the maximum exposure per instrument <span class="tclink" target-tab="tc-view-6" target-section="product_section">click here</span>. iFOREX has the right, at its sole discretion to cancel or change such a limitation at any given moment without any prior notice.
                  <br><br>
                  <b>Hedging</b><br>
                  Hedging is defined as the opening of two Transactions on the same instrument or underlying asset at different directions (one "buy" and the other "sell"), whether or not at the same time and whether or not for the same quantity. iFOREX considers hedging transactions for the purpose of calculating the minimum margin on a cumulative basis or on a "net" basis. Furthermore, iFOREX considers the closing of one of the hedged Transactions as the opening of a new Transaction which amount’s equals to the amount of the remaining Transaction.
                  <br><br>
                  <b>Netting of Transactions</b><br>
                  In the case where more than one deal needs to close simultaneously in an account, iFOREX will close all open positions as a bulk. The transaction number assigned on each closed position is set based on FIFO rules. This means that upon the closing of the positions, the first position opened will receive the lowest transaction number and the last position opened will receive the highest transaction number.
                  <br><br>
                  <b>Unauthorized Trading Practices</b><br>
                  iFOREX supports fair trading and does not allow practices which exercise abusive trading such as lag trading, price manipulation, time manipulation or any other practices which are illegal and/or are utilized to give the Client an unfair advantage. Examples for such forbidden practices can be, but not limited to, any of the following:
              </p>
              
              <ul class="list-style-disc-small mt-3 mb-2">
                  <li>
                  <b>Scalping</b> is a trading strategy that attempts to exploit small changes in prices. Traders who implement this strategy will create many short-term positions, usually closing them within seconds or minutes.
                  </li>
                  <li>
                  <b>Automation</b> (e.g. EAs) or algorithmic trading is the use of electronic platforms for entering trading orders with an algorithm which executes pre-programmed trading instructions whose variables may include timing, price, or quantity of the order, or in many cases initiating the order by a "robot", without human intervention.
                  </li>
                  <li>
                  <b>API trading</b> is an application programming interface refers to all trading that uses a software program to interact with other programs. The API acts as the middleman between the trader and the market, relaying orders and retrieving information as needed.
                  </li>
                  <li>
                  <b>‘Multiple accounts’</b> refers to the situation whereby one client sets up two or more accounts in order to disingenuously receive multiple account-related benefits from iFOREX.
                  </li>
              </ul>

              <p>Where the Company has any indication or suspicion, at the Company’s sole and absolute discretion, of any form of an exploitation, illegal, unfair, unauthorized and/or abusive trading practices, utilized to give the Client an unfair advantage, and/or of fraud, manipulation or breach of the Company’s agreements, policies, terms and conditions, the Company shall have the right, at its sole and absolute discretion, and without derogating from its rights under its agreements with the client and applicable law, to nullify and cancel all transactions carried in relevant accounts, including all profits or losses generated therein, remove any bonuses granted to the client and/or block the account.</p>
  
              <p>
                  <b>Errors in Rates</b><br>
                  Online trading technology is not perfect and in rare cases, the feed can be disrupted. This may only last for a moment, but when it does, prices can often become affected. While it may be tempting to place an "arbitrage transaction", keep in mind that in such situations, the prices do not reflect the true market price and your actual fill may be many pips away from the displayed price. In the event that trades are executed at prices not actually offered by iFOREX, iFOREX reserves the right to reverse such trades as they are not considered valid trades. Keep in mind that these instances are usually rare, and by not trading during these moments, traders can avoid the risk associated with the above scenarios.
                  <br><br>
                  <b>Maintenance Fee</b><br>
                  Clients’ accounts in which there have been no trading activity for a period of twelve (12) consecutive months may be charged with a quarterly maintenance fee of US$15 or the account’s entire Equity if the Equity is less than US$15.
                  <br><br>
                  <b>Currency Conversion Fees</b><br>
                  Trading Financial Instruments in a different currency to the client’s trading account currency may expose said client to currency conversion fees.
                  <br><br>
                  Funding or withdrawing funds from a trading account using a credit card in a currency other than the trading account currency may be subject to conversion fees charged by the client’s credit card company.
                  <br><br>
                  <b>Unavailability and inaccessibility of trading services from certain Restricted Countries</b><br>
                  The trading platform and/or trading services will not be made possible or available from certain Restricted Countries including, without limitations to, the USA. For further information regarding limitations on the use of, or of the accessibility to, Company’s services or website from certain Restricted Countries, including the list of the Restricted Countries, kindly click <a href="/legal/restricted-countries" target="_blank" rel="noopener">here</a>.
                  <br><br>
                  For more information about trading, see our <a href="/legal/client_agreement.pdf" target="_blank" rel="noopener">Client Agreement</a>.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Overnight Financing",
          content_before: `
                  <p>
                      When trading leveraged Forex CFDs with iFOREX, your open deals are subject to Overnight Financing at the end of each trading day. This Overnight Financing may be subject to credit or debit, calculated on the basis of the relevant interest rates for the currencies in which the underlying instrument is traded, plus a mark-up. The mark-up for currency pairs starts at 0.75% and can be higher as well as differ between Long (Buy) and Short (Sell) positions. Please review the below table for the latest Overnight Financing levels.
                      <br><br>
                      If the calculated Overnight Financing Percentage is positive, it means that an applicable amount will be added (credited) to your account balance. A negative Overnight Financing Percentage means that an applicable amount will be subtracted (debited) from your account balance.
                      <br><br>
                      You can find the relevant Overnight Financing percentage, amounts and their related running times on both the Deal and Limit forms, under Tools, within the ‘Market Info’ tab. To calculate the Overnight Financing, which your account will be debited or credited with, simply multiply the Overnight Financing percentage with the size of your deal. The running time of the Overnight Financing process for each CFD is detailed in the deal form's ‘Instrument Info Tool’ under "Overnight Financing (GMT)". The calculated value and percentage of an instrument's Overnight Financing applies for 1 day. CFDs that are traded 5 days a week will be credited or debited with a value 3 times the displayed value during the last day of its underlying asset trading week, as it covers the entire weekend period. The Overnight Financing amount is quoted according to the currency of the CFD. However, should the quoted CFD’s currency differ from the account currency, it will be converted to the account’s currency.
                      <br><br>
                      <u><b><u>Formula</u></b></u><br><br>
                      Calculation of Overnight Financing Percentage when you Buy (Long Positions):
                      <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">interest rate of the other currency - interest rate of the base currency + Long markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                      Calculation of Overnight Financing Percentage when you Sell (Short Positions):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">interest rate of the other currency - interest rate of the base currency - Short markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      To calculate the Overnight Financing Amount, simply multiply the percentage by the deal amount:<br><br>Overnight Financing Amount = Deal Amount × Overnight Financing Percentage
                      <br><br><br>
                      <u><b><u>Examples</u></b></u><br><br>
                      <b>Example I</b><br><br>
                      This example involves a situation whereby the Interbank Rate difference is HIGHER than the markup. In such cases, your account will be debited when you go Long and credited when you go Short:
                      
                  </p>
  
                  <ul class="list-style-dashed mb-4">
                      <li>Instrument = EUR/USD (Euro vs. US Dollar)</li>
                      <li>EUR (base currency) interest rate (annualized) = -0.37% = -0.0037</li>
                      <li>USD (other currency) interest rate (annualized) = 1.08% = 0.0108</li>
                      <li>Interbank Rates difference = 1.45% = 0.0145</li>
                      <li>Long Markup = 0.75% = 0.0075</li>
                      <li>Short Markup = 0.75% = 0.0075</li>
                      <li>Deal Amount value expressed in the other currency = 106,550 USD (100,000 EUR at Current Closing Rate of 1.0655)</li>
                  </ul>
                  <p>
                      Overnight Financing Percentage when you Buy (Long Positions):<br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                      Overnight Financing Amount = 106,550 × (-0.0000611) = -6.51 USD, meaning 6.51 USD charge per day
                      
                      
                      <br><br><br>
                      Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                      Overnight Financing Amount = 106,550 × 0.00001944 = 2.07 USD credit per day
                      <br><br><br>
                      
                      <b>Example II</b><br><br>
                      
                      This example involves a situation whereby the Interbank Rate difference is HIGHER than the markup and the Long and Short markups are different. In such cases, your account will be debited when you go Long and credited when you go Short:
                  </p>
                  
                  <ul class="list-style-dashed mb-4">
                      <li>Instrument = EUR/TRY (Euro vs. Turkish Lira)</li>
                      <li>EUR (base currency) interest rate (annualized) = -0.37% = -0.0037</li>
                      <li>TRY (other currency) interest rate (annualized) = 22.75% = 0.2275</li>
                      <li>Interbank Rates difference = 23.12% = 0.2312</li>
                      <li>Long Markup = 0.75% = 0.0075</li>
                      <li>Short Markup = 14.00% = 0.14</li>
                      <li>Deal Amount value expressed in the other currency = 620,000 TRY (100,000 EUR at Current Closing Rate of 6.2000)</li>
                  </ul>
                  
                  <p>
                      Overnight Financing Percentage when you Buy (Long Positions):<br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                      Overnight Financing Amount = 620,000 × (-0.000663) = -411 TRY, meaning 411 TRY charge per day (≅80 USD)
                      <br><br><br>

                      Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                      Overnight Financing Amount = 620,000 × (0.000253) = 157 TRY, meaning 157 TRY credit per day (≅30 USD)
                      <br><br><br>
                      <b>Example III</b><br><br>
                      This example involves a situation whereby the Interbank Rate difference is LOWER than the negative markup. In such cases, your account will be debited when you go Short and credited when you go Long:
                  </p>
                  
                  <ul class="list-style-dashed mt-4 mb-4">
                      <li>Instrument = USD/JPY (US Dollar vs. Japanese Yen)</li>
                      <li>USD (base currency) interest rate (annualized) = 1.08% = 1.08</li>
                      <li>JPY (other currency) interest rate (annualized) = -0.09% = -0.0009</li>
                      <li>Interbank Rates difference = -1.17% = -0.0117</li>
                      <li>Long Markup = 0.75% = 0.0075</li>
                      <li>Short Markup = 0.75% = 0.0075</li>
                      <li>Deal Amount value expressed in the other currency = 10,341,000 JPY (100,000 USD at Current Closing Rate of 103.41)</li>
                  </ul>
                  
                  <p>
                      Overnight Financing Percentage when you Buy (Long Positions):<br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                      Overnight Financing Amount = 10,341,000 ×0.00001167 = 120.65 JPY credit per day (≅1.1 USD)
                      <br><br><br>

                      Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                      Overnight Financing Amount = 10,341,000 ×(-0.0000533) = -551.52 JPY, meaning 551.52 JPY charge per day (≅5.3 USD)
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* Overnight Financing settlements may take up to 15 minutes to process at the end of the trading day, following which your account will be credited or debited appropriately.</p>`,
          table_titles: [
            "Instrument",
            "Daily Overnight Financing Percentage (Sell)",
            "Daily Overnight Financing Percentage (Buy)",
            "Overnight Financing (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Index, Commodity and Crypto CFDs",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Overnight Financing",
          content_before: `
              <p>
                 When trading Index, Commodity and Crypto CFDs with iFOREX, your open deals are subject to Overnight Financing at the end of each trading day. This Overnight Financing may be subject to credit or debit, calculated on the basis of the relevant interest rates for the currencies in which the underlying instrument is traded, plus a mark-up. The mark-up for Cryptocurrencies can be significantly higher due to Cryptocurrencies’ extreme market conditions. Please review the below table for the latest Overnight Financing levels.
                  <br><br>
                  If the calculated Overnight Financing Percentage is positive, it means that an applicable amount will be added (credited) to your account balance. A negative Overnight Financing Percentage means that an applicable amount will be subtracted (debited) from your account balance.
                  <br><br>
                  You can find the relevant Overnight Financing percentage, amounts and their related running times on both the Deal and Limit forms, under Tools, within the ‘Market Info’ tab. To calculate the Overnight Financing, which your account will be debited or credited with, simply multiply the Overnight Financing Percentage with the size of your deal. The running time of the Overnight Financing process for each CFD is detailed in the deal form's ‘Instrument Info Tool’ under "Overnight Financing (GMT)". The calculated value and percentage of an instrument's Overnight Financing applies for 1 day. CFDs that are traded 5 days a week will be credited or debited with a value 3 times the displayed value during the last day of its underlying asset trading week, as it covers the entire weekend period. The Overnight Financing amount is quoted according to the currency of the CFD. However, should the quoted CFD’s currency differ from the account currency, it will be converted to the account’s currency.
                  <br><br>
                  <u><b><u>Formula</u></b></u><br><br>
                  Calculation of Overnight Financing Percentage when you Buy (Long Positions):<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">interest rate + markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                  Calculation of Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">interest rate - markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                  To calculate the Overnight Financing Amount, simply multiply the percentage by the deal amount:<br><br>Overnight Financing Amount = Deal Amount × Overnight Financing Percentage
                  <br><br><br>
                  <u><b><u>Examples</u></b></u><br><br>
                  <b>Example I</b><br><br>
                  This example involves a situation whereby the Interbank Rate is HIGHER than the markup. In such cases, your account will be debited when you go Long and credited when you go Short:
              </p>
  
              <ul class="list-style-dashed mb-2">
                  <li>Instrument = Brazil Ibovespa</li>
                  <li>Brazilian Real (BRL) interest rate (annualized) = 9.567% = 0.09567</li>
                  <li>Markup = 2.5% = 0.025</li>
                  <li>Deal Amount value expressed in currency = 127,380 BRL (2 Index contracts at Current Closing Rate of 63690 BRL per contract)</li>
              </ul>
              <br>
  
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):<br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                  Overnight Financing Amount = 127,380 × (-0.0003351944) = -42.70 BRL, meaning a 42.70 BRL charge per day (≅13.58 USD)
                  <br><br><br>
                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                  Overnight Financing Amount = 127,380 × 0.00019630556 = 25 BRL credit per day (≅7.95 USD)
                  <br><br><br>
                  <b>Example II</b><br><br>
                  This example involves a situation whereby the Interbank Rate is LOWER than the markup. In such cases your account will be debited each night regardless of the direction of your position:
              </p>
              
              <ul class="list-style-dashed mb-2">
                  <li>Instrument = Oil (Crude Light WTI)</li>
                  <li>US Dollar (USD) interest rate (annualized) = 1.08% = 0.0108</li>
                  <li>Markup = 2.5% = 0.025</li>
                  <li>Deal Amount value expressed in currency = 53,250 USD (1,000 Oil barrels at Current Closing Rate of 53.25 USD per barrel)</li>
              </ul>
              <br>
              
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):
                  
                  <br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                  Overnight Financing Amount = 53,250 × (-0.00009944) = -5.30 USD, meaning a 5.30 USD charge per day
                  <br><br><br>
                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                  Overnight Financing Amount = 53,250 × (-0.00003944) = -2.10 USD, meaning a 2.10 USD charge per day
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Overnight Financing settlements may take up to 15 minutes to process at the end of the trading day, following which your account will be credited or debited appropriately.</p>`,
          table_titles: [
            "Instrument",
            "Daily Overnight Financing Percentage (Sell)",
            "Daily Overnight Financing Percentage (Buy)",
            "Overnight Financing (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Contracts' Rollover Dates",
          content_before: `<p>
                      Every CFD that is based on future contract (i.e. commodities and indices) has a rollover date.
                      <br><br>
                      Upon reaching the relevant instrument’s rollover date, all open future contract CFD positions will be rolled-over to the next contract, so that the positions remain open with the new future contract.
                      <br><br>
                      Upon effectuating such rollover, the Position’s open P/L (Profit / Loss) will express the price difference between the expired and new contract prices, as well as include a mark-up spread. All the associated Limit Orders levels shall be automatically adjusted according to the new future contract price.
                      <br><br>
                      For example, if the last price of the WTI Oil February contract is $50.125 and the market price of the following contract (March) at that time is $50.805, then the price level of all the outstanding limit orders will be updated upwards by $0.68.
                      <br><br>
                      The rollover dates of contracts depend on the instrument you are trading, and those set out below shall be the sole rollover dates applicable to iFOREX's CFD:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Contract Month", "Contract Rollover (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Commodities", "Indices"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Share and ETF CFDs",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Overnight Financing",
          content_before: `<p>
                When trading Share and ETF CFDs with iFOREX, your open deals are subject to Overnight Financing at the end of each trading day. This Overnight Financing may be subject to credit or debit, calculated on the basis of the relevant interest rates for the currencies in which the underlying instrument is traded, plus a mark-up. Please review the below table for the latest Overnight Financing levels.
                  <br><br>
                  If the calculated Overnight Financing Percentage is positive, it means that an applicable amount will be added (credited) to your account balance. A negative Overnight Financing Percentage means that an applicable amount will be subtracted (debited) from your account balance.
                  <br><br>
                  You can find the relevant Overnight Financing percentage, amounts and their related running times on both the Deal and Limit forms, under Tools, within the ‘Market Info’ tab. To calculate the Overnight Financing, which your account will be debited or credited with, simply multiply the Overnight Financing Percentage with the size of your deal. The running time of the Overnight Financing process for each CFD is detailed in the deal form's ‘Instrument Info Tool’ under "Overnight Financing (GMT)". The calculated value and percentage of an instrument's Overnight Financing applies for 1 day. CFDs that are traded 5 days a week will be credited or debited with a value 3 times the displayed value during the last day of its underlying asset trading week, as it covers the entire weekend period. The Overnight Financing amount is quoted according to the currency of the CFD. However, should the quoted CFD’s currency differ from the account currency, it will be converted to the account’s currency.
                  <br><br>
                  <u><b><u>Formula</u></b></u><br><br>
                  Calculation of Overnight Financing Percentage when you Buy (Long Positions):
                  
                  <br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">interest rate + markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Calculation of Overnight Financing Percentage when you Sell (Short Positions):

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">interest rate - markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                  To calculate the Overnight Financing Amount, simply multiply the percentage by the deal amount:<br><br>Overnight Financing Amount = Deal Amount × Overnight Financing Percentage
                  <br><br><br>
                  <u><b><u>Examples</u></b></u><br><br>
                  <b>Example I</b><br><br>
                  This example involves a situation whereby the Interbank Rate is HIGHER than the markup. In such cases your account will be debited when you go Long and credited when you go Short:
              </p>
  
              <ul class="list-style-dashed mb-4">
                  <li>Instrument = Gazprom (GAZP)</li>
                  <li>Russian Ruble (RUB) interest rate (annualized) = 9.5% = 0.095</li>
                  <li>Markup = 5% = 0.05</li>
                  <li>Deal Amount value expressed in currency = 2,459,000 RUB (20,000 Shares at Current Closing Rate of 122.95 RUB per share)</li>
              </ul>
              
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):<br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

              Overnight Financing Amount = 2,459,000 × (-0.0004) = -983.60 RUB, meaning a 983.60 RUB charge per day (≅17.52 USD)

                  <br><br><br>

                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Overnight Financing Amount = 2,459,000 × 0.000125 = 307.38 RUB credit per day (≅5.48 USD)
                <br><br><br>

                  <b>Example II</b><br><br>
                  This example involves a situation whereby the Interbank Rate is LOWER than the markup. In such cases, your account will be debited each night regardless of your position’s direction:<br>
              </p>
  
              <ul class="list-style-dashed mb-2">
                  <li>Instrument = Apple (AAPL)</li>
                  <li>US Dollar (USD) interest rate (annualized) = 1.08% = 0.0108</li>
                  <li>Markup = 5% = 0.05</li>
                  <li>Deal Amount value expressed in currency = 70,600 USD (500 Shares at Current Closing Rate of 141.20 USD per share)</li>
              </ul>
              <br>
  
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):<br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                  Overnight Financing Amount = 70,600 × (-0.000169) = -11.93 USD, meaning a 11.93 USD charge per day
                  <br><br><br>
                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                  Overnight Financing Amount = 70,600 × (-0.000109) = -7.70 USD, meaning a 7.70 USD charge per day
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Overnight Financing settlements may take up to 15 minutes to process at the end of the trading day, following which your account will be credited or debited appropriately.</p>`,
          table_titles: [
            "Instrument",
            "Daily Overnight Financing Percentage (Sell)",
            "Daily Overnight Financing Percentage (Buy)",
            "Overnight Financing (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Dividends",
          content_before: `<p>
                      In the event of a distribution of cash dividends in relation to a share CFD, a dividend adjustment will be made to the Client’s Balance with respect to the underlying share CFD positions held by the Client at the end of the business day preceding the ex-dividend date. The dividend adjustment shall be calculated based on the size of the dividend, the size of the Client’s position and whether it is a buy or a sell transaction. In long positions the adjustment shall be credited to the Client’s Balance and in short positions the adjustment shall be debited from the Client’s Balance. Dividends shall be credited or debited from the Client’s Balance outside of the underlying shares' trading hours and before the opening of the shares' next trading day and are contingent upon the Client holding their respective position at the time of the dividend adjustment. During this period, in order to keep the fair value of the Client’s Equity until the opening of the next trading day, the Company shall adjust the Client’s position in accordance with the dividend amount debited or credited from the Client’s Balance.
                      <br><br>
                      <u>Example:</u><br>
                      Coca-Cola issues a dividend of 0.35 USD per share. <br>
                      The Ex-Dividend date is November 29th and the settlement date in iFOREX is November 28th at 22:05 GMT. <br>
                      The closing price before the settlement is 41.65. <br>
                      A client that holds a Long position of 5,000 shares will be credited with 0.35 x 5,000 = 1,750 USD if his deal is open at the settlement date. <br>
                      If the client holds a Short position, similar amount will be deducted from the Balance of the trading account of such client. <br>
                      The share price will be adjusted, during the afterhours, from 41.65 to 41.30, which equals to the last share price minus the dividend amount.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"There's currently no information on future dividends",
          table_titles: [
            "Share / ETF",
            "Market",
            "Dividend Amount",
            "Date and Time (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Stock Dividends, Stock Splits and other Corporate Actions",
          content_before: `<p>
              
          Corporate Actions are certain events that effect a public company's share value. Unless mentioned otherwise hereunder in respect of specific Corporate Actions, upon the occurrence of a Corporate Action in a specific share, iFOREX shall liquidate any open position(s) of the relevant CFD(s) including, where required, the removal of any limit order(s) of such CFD(s).
          <br><br>
            Corporate Actions in iFOREX include Rights Offering, Delisting and any other event which materially affects or may materially affect the shares’ price (including material company announcements, takeovers, mergers, insolvency etc.).
            <br><br>

            <b>Stock Dividends</b><br>

            Stock Dividend on-exchange do not alter the total value of stocks for those who hold them but rather change the number of stocks and their price.<br>
            You will receive the “Adjustment Factor” for each share held.<br>
            Any of your open deal(s) and/or limit(s) during the Stock Dividend date and time, will have its amount, rate, and associated limit(s) adjusted accordingly (including the account balance due to any required P/L adjustments, if applicable).
            For example, in a Stock Adjustment with an Adjustment factor of 1.8 then 1 stock becomes 1.8 stocks after the event and the price is divided by 1.8, leaving the overall value of shares unchanged.<br>
            E.g., 1 stock priced at $1,000 will become 1.8 stocks priced at $555.56 after the event: 1x $1,000 = 1.8 x$555.56 = $1,000 value<br><br>


            <b>Stock Splits and Reverse Stock Splits specific rules</b><br>
                Stock splits and reverse stock splits on-exchange do not alter the total value of stocks for those who hold them, but rather change the number of stocks and their price. These splits are usually implemented when the stock price is either too high or too low. Should an open deal/limit encounter a stock split, its amount, rate and associated limit(s) level will be adjusted accordingly (including the account’s balance, due to required PL adjustments, if applicable).
                <br><br>
                For example, in a 1:10 split, 1 stock becomes 10 stocks after the event and the price is divided by 10, leaving the overall value of shares unchanged. E.g., 1 stock priced at $1,000 will become 10 stocks priced at $100 after the event: 1x $1,000 = 10 x$100 = $1,000 value.
                <br><br>
                Please find below a list of the upcoming Corporate Actions:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"There's currently no information on future Corporate Actions",
          table_titles: ["Share / ETF", "Market", "Type", "Date and Time (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Earnings Reports",
          content_before: `<p>
                                An earnings report is a periodic filing made by public companies to report their performance. By analyzing quarterly earnings reports, investors can gauge the financial health of the company. The announcement of earnings for a company, particularly for a popular company with a high market capitalization, can affect its share prices, which can cause it to fluctuate widely on days when such quarterly earnings reports are released.
                                <br><br>
                                For that reason, maximum exposure and margin requirements of the relevant shares will be modified throughout the period of publication. The maximum exposure per share will be lowered to $50,000 and the margin requirement will double.
                                <br><br>
                                To view the schedule of earnings reports for each share, please open the mobile app and navigate to the 'Info' tab within the trading ticket of the specific share. Here, under 'Coming Events', you will find the date of the upcoming earnings report. 
                              </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  